import { render, staticRenderFns } from "./AddedTruckersList.vue?vue&type=template&id=50ed4e7a&"
import script from "./AddedTruckersList.vue?vue&type=script&lang=js&"
export * from "./AddedTruckersList.vue?vue&type=script&lang=js&"
import style0 from "./AddedTruckersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports